import { useResource__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResource';
import { getData } from '../utils/getRelationshipData';

/** Check if a `folder` resource is a project */
export const useProjectCheck = (folderId: string, projectId?: string) => {
  const folder = useResource__ALPHA({
    resourceId: folderId,
    resourceType: 'folder'
  });

  const isRootFolder = folder.resource && !getData(folder.resource, 'parent');

  const project = useResource__ALPHA({
    resourceId: projectId,
    resourceType: projectId && !isRootFolder ? 'project' : undefined
  });

  const isProjectSelf =
    isRootFolder ||
    (project.resource && getData(project.resource, 'node')?.id === folderId);

  return isProjectSelf;
};
